import * as React from 'react'
import MediaQuery from 'react-responsive'

import { getArticleFormattedDateTime } from '../../../utils/DateUtils'

import {
  NewsContainer,
  NewsTitle,
  NewsDescription,
  NewsImage,
  NewsDate,
  ReadFullStory,
  NewsImageHolder,
  LinkHolder,
  NewsDescriptionHolder,
  LinkHolderText
} from './styledComponents'
import './styles.global.css'

class NewsCard extends React.Component {
  render() {
    const { news, readFullStoryText, watchVideoText } = this.props
    const {
      id,
      imageUrl,
      altText,
      mobileImageurl,
      title,
      date,
      description,
      newsUrl,
      isVideo,
      leftColor,
      rightColor
    } = news
    const articleFormattedDate = getArticleFormattedDateTime(date)
    const idForimageAndReadArticle = altText
      .split('-')
      .join('')
      .split(/\s+/)
      .join('-')
    let clampClass = 'line-clamp line-clamp-3'
    if (!imageUrl) {
      clampClass = 'line-clamp line-clamp-6'
    }
    return (
      <NewsContainer imageUrl={imageUrl} mobileImageurl={mobileImageurl}>
        <MediaQuery query="(min-device-width: 768px)">
          {imageUrl ? (
            <NewsImageHolder
              id={`${id}Image`}
              leftColor={leftColor}
              rightColor={rightColor}
              href={newsUrl}
              target="_blank"
              rel="noopener"
            >
              <NewsImage
                dataSrc={imageUrl}
                alt={altText}
                draggable={false}
                className="lazyload"
              />
            </NewsImageHolder>
          ) : null}
        </MediaQuery>
        <MediaQuery query="(max-device-width: 767px)">
          {mobileImageurl ? (
            <NewsImageHolder
              id={`${id}Image`}
              leftColor={leftColor}
              rightColor={rightColor}
              href={newsUrl}
            >
              <NewsImage
                dataSrc={mobileImageurl}
                alt={altText}
                draggable={false}
                className="lazyload"
              />
            </NewsImageHolder>
          ) : null}
        </MediaQuery>
        <NewsDescriptionHolder
          imageUrl={imageUrl}
          mobileImageurl={mobileImageurl}
          description={description}
        >
          <NewsTitle
            dangerouslySetInnerHTML={{
              __html: title
            }}
            as="article"
          />
          <NewsDate as="article">{articleFormattedDate}</NewsDate>
          <MediaQuery query="(min-device-width: 768px)">
            {description ? (
              <NewsDescription className={clampClass} as="article">
                {description}
              </NewsDescription>
            ) : null}
            {newsUrl ? (
              <LinkHolder>
                <ReadFullStory
                  href={newsUrl}
                  target="_blank"
                  rel="noopener"
                  as="a"
                >
                  {isVideo ? (
                    <LinkHolderText id={`${id}Video`}>
                      {watchVideoText}
                    </LinkHolderText>
                  ) : (
                    <LinkHolderText id={`${id}ReadStory`}>
                      {readFullStoryText}
                    </LinkHolderText>
                  )}
                </ReadFullStory>
              </LinkHolder>
            ) : null}
          </MediaQuery>
        </NewsDescriptionHolder>
      </NewsContainer>
    )
  }
}

export default NewsCard



// WEBPACK FOOTER //
// ./src/components/IbcNews/NewsCard/index.js